import React from "react";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import AllChats from "../../../sections/MessageCentre/AllChats";
import { CUSTOMER_INBOX_CONTENT_CLASS } from "../../../sections/CustomerDashboard/shared/customerLayoutSpec";

const Blocked = () => {
  return (
    <DashboardMainContainer className="!bg-white">
      <div className={CUSTOMER_INBOX_CONTENT_CLASS}>
        <div className="bg-white overflow-hidden">
          <AllChats profileLinkOption={true} moveToChat={() => {}} filterType="blocked" />
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default Blocked;
